
require("../src/wmcanvas/wmcanvas.css")

window.WMCanvas = require("../src/wmcanvas/wmcanvas-konva.js")
